export default function arrayObjectIndexOf(myArray, searchTerm, property) {
  for (let i = 0, len = myArray.length; i < len; i += 1) {
    if (myArray[i][property] === searchTerm) { return i; }
  }
  return -1;
}



// WEBPACK FOOTER //
// ./src/js/arrayObjectIndexOf.js